
// const schema = {
//   branches: {
//     type: 'array',
//     default: [
//       { id: 'a39bfc75-57ca-479f-b598-39e93ce19e7f', name: 'store-1', alias: 'store-1' },
//       { id: 'c9b17650-d086-4e2a-b555-75bef65adf2f', name: 'store-2', alias: 'store-2' },
//       { id: '2111acef-3e11-436d-a885-17c2bde40f60', name: 'store-3', alias: 'store-3' },
//       { id: 'f440ecb6-7061-4749-9852-412c16b5f90b', name: 'store-4', alias: 'store-4' },
//       { id: 'd0d1f78a-b969-43f5-b3dd-2a7e269034e2', name: 'store-5', alias: 'store-5' },
//       { id: '641e99db-d36f-4a6e-8a0e-1d1b47fe33f6', name: 'store-6', alias: 'store-6' },
//       { id: '217982df-10ab-4f50-a02a-2ab573459d2e', name: 'store-7', alias: 'store-7' },
//     ],
//   },
// }

// const store = new Store({ schema })

const state = {
  // list: store.get('branches'),
  list: [],
}

const mutations = {
  SET_BRANCH_NAME(state, { index, name }) {
    state.list[index].name = name
    // store.set({ branches: state.list })
  },
  SET_BRANCH_LIST(state, branches) {
    state.list = [...branches]
  },
}

const actions = {
  setBranchName({ commit, state }, { id, name }) {
    const index = state.list.findIndex(e => e.id === id)
    if (index > -1) {
      commit('SET_BRANCH_NAME', { index, name })
    }
  },
  setBranchList({ commit }, branches) {
    commit('SET_BRANCH_LIST', branches)
  },
}

export default {
  namespaced: true,
  strict: true,
  state,
  mutations,
  actions,
}
